import { render } from "./upcommingvisits.vue?vue&type=template&id=6b0adb69"
import script from "./upcommingvisits.vue?vue&type=script&lang=js"
export * from "./upcommingvisits.vue?vue&type=script&lang=js"

import "./upcommingvisits.vue?vue&type=style&index=0&id=6b0adb69&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__